import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M190.144 190.148c-190.674 190.674-190.674 498.922 0 689.595s498.925 190.674 689.599 0c190.674-190.674 190.674-498.922 0-689.595s-498.925-190.674-689.599 0zM831.468 534.947c0 26.892-21.723 48.616-48.616 48.616h-199.295v199.295c0 26.892-21.723 48.616-48.616 48.616s-48.617-21.723-48.617-48.616v-199.295h-199.293c-26.895 0-48.617-21.723-48.617-48.616 0-26.897 21.722-48.618 48.617-48.618h199.293v-199.294c0-26.894 21.724-48.617 48.617-48.617s48.616 21.722 48.616 48.617v199.294h199.295c26.205 0 48.274 22.067 48.616 48.618z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgAdd);
export default ForwardRef;
